import { render, staticRenderFns } from "./PanelAdminPayAgreements.vue?vue&type=template&id=7d078b86&scoped=true&"
import script from "./PanelAdminPayAgreements.vue?vue&type=script&lang=js&"
export * from "./PanelAdminPayAgreements.vue?vue&type=script&lang=js&"
import style0 from "./PanelAdminPayAgreements.vue?vue&type=style&index=0&id=7d078b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d078b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d078b86')) {
      api.createRecord('7d078b86', component.options)
    } else {
      api.reload('7d078b86', component.options)
    }
    module.hot.accept("./PanelAdminPayAgreements.vue?vue&type=template&id=7d078b86&scoped=true&", function () {
      api.rerender('7d078b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelAdminPayAgreements.vue"
export default component.exports